function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgDiamondOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.076 5.235 2.5-4A.5.5 0 0 1 3 1h10a.5.5 0 0 1 .424.235l2.496 3.993a.497.497 0 0 1 .08.26V5.5a.497.497 0 0 1-.11.313L8.417 15.28a.492.492 0 0 1-.482.217.489.489 0 0 1-.34-.203L.107 5.81a.5.5 0 0 1-.032-.575ZM14.469 6l-4.901 6.208L11.868 6h2.601Zm-4.055-1L7.996 2.254 5.581 5h4.833ZM3.762 5l-.878-2.37L1.403 5h2.36Zm-.044-3 .939 2.537L6.887 2h-3.17Zm5.387 0h3.176l-.94 2.54L9.104 2Zm4.01.627L14.6 5h-2.363l.88-2.373ZM1.533 6h2.601l2.3 6.208L1.532 6ZM10.8 6H5.2L8 13.56 10.8 6Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgDiamondOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgDiamondOutlinedIcon);
export default Memo;